import Switch from 'react-switch';

interface IFilterSwitchButton {
  label: string;
  checked?: boolean;
  onChange?: () => void;
  disabled?: boolean;
}

const FilterSwitchButton: React.FC<IFilterSwitchButton> = ({
  label,
  checked = false,
  onChange = () => {},
  ...rest
}) => {
  const onSwitchChange = () => {
    onChange();
  };

  return (
    <div className="flex items-center justify-between">
      <span className="font-interMedium text-sm">{label}</span>
      <div className="">
        <Switch
          onChange={onSwitchChange}
          checked={checked}
          uncheckedIcon={false}
          checkedIcon={false}
          offColor={'#ccc'}
          onColor={'#000'}
          className="scale-75"
          {...rest}
        />
      </div>
    </div>
  );
};

export default FilterSwitchButton;
